import React from 'react'
import classNames from 'classnames'
import style from './styles/section.module.scss'

interface IProps {
  className?: string
  id?: string
}

const Section = ({
  className = '',
  id,
  children
}: React.PropsWithChildren<IProps>): React.ReactElement => {
  return (
    <section
      className={classNames({
        [style.section]: true,
        [className]: Boolean(className)
      })}
      id={id}
    >
      {children}
    </section>
  )
}

export default Section
